import {AppState, RequestStatus} from '../reducerType';

export const selectGoogleAuthStatus = (state: AppState): RequestStatus => state.sso.googleAuthStatus;